enum eNotificationType {
  Success =1, 
  Error = 2,
  Info = 3,
  Alert = 4
}

export default eNotificationType;
